import React from "react";
import AuthBg from "assets/images/png/auth-bg.jpg";
import { MuiBox } from "components/atoms";
import { Outlet } from "react-router-dom";

const HelpAndOtherPolicyLayout = () => {
  return (
    <MuiBox
      sx={{
        height: "100dvh",
        overflow: "scroll",
      }}
      className="no-scrollbar"
    >
      <MuiBox
        sx={{
          backgroundImage: `url("${AuthBg}")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "0",
          minHeight: "100dvh",
        }}
      >
        <Outlet />
      </MuiBox>
    </MuiBox>
  );
};

export default HelpAndOtherPolicyLayout;
